import {
	OPEN_MATCH_ROOM,
	LEAVE_MATCH_ROOM,
	CLOSE_MATCH_ROOM_BEGIN,
	CLOSE_MATCH_ROOM_FAIL,
} from 'react/redux/actions/matchRoom';
import { CURRENT_MATCH_UPDATE } from 'react/redux/actions/matchmaking';

// A match that started this long before the page loaded still counts as
// starting now: the player accepted it and landed here.
const JUST_STARTED_GRACE_MS = 30000;

function toMilliseconds(time) {
	if(!time) {
		return null;
	}
	const value = Number(time.valueOf());
	return Number.isFinite(value) ? value : null;
}

// Only a match that starts while the page is open takes over the Chat view;
// one already running when the page loaded leaves the room the URL asked for.
function startedDuringThisPage(match, pageLoadedAt) {
	const startedAt = toMilliseconds(match.start_time) ?? toMilliseconds(match.created_at);
	if(startedAt === null) {
		return true;
	}
	return startedAt >= pageLoadedAt - JUST_STARTED_GRACE_MS;
}

const initialState = {
	// When this page loaded (client clock).
	pageLoadedAt: Date.now(),
	// The Chat view shows the match room in its conversation column.
	open: false,
	// The match the room belongs to; a different id means a new match.
	matchId: null,
	// The match being closed (hidden until the server answers).
	closingMatchId: null,
	closeError: null,
};

export default (state = initialState, action) => {
	switch(action.type) {
		case OPEN_MATCH_ROOM:
			return { ...state, open: true, closeError: null };
		case LEAVE_MATCH_ROOM:
			return { ...state, open: false };
		case CLOSE_MATCH_ROOM_BEGIN:
			return { ...state, open: false, closingMatchId: action.payload, closeError: null };
		case CLOSE_MATCH_ROOM_FAIL:
			return { ...state, open: true, closingMatchId: null, closeError: action.payload };
		case CURRENT_MATCH_UPDATE: {
			const match = action.payload;
			if(!match) {
				return { ...initialState, pageLoadedAt: state.pageLoadedAt };
			}
			if(match.id === state.matchId) {
				return state;
			}
			// A match that starts now opens its room, as a new match used to
			// switch to the match tab.
			return {
				...initialState,
				pageLoadedAt: state.pageLoadedAt,
				open: startedDuringThisPage(match, state.pageLoadedAt),
				matchId: match.id,
			};
		}
		default:
			return state;
	}
};
